import React from 'react';
import Navbar from '../Components/Navbar/Navbar';

const About = () => {
    return (
        <>
            <Navbar bgColor={"#fff"} textColor={'#fff'} />
            <div style={{ marginTop: "59.5px" }} className="container">
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "span", marginRight: "1rem", paddingTop: "0.5rem" }} className="div__line"></div>
                    <h1 className='primary__heading' style={{ fontSize: "25px" }}>About</h1>
                </div>
                <h1 className='primary__heading' style={{ fontSize: "64px", color: "gray", marginBottom: "3rem", lineHeight: "58px" }}>Welcome <br /> </h1>
                <p>Hey, I'm Rokan Uddin. I'm an ambitious Full-Stack Web Developer. Who is comportable working with React.js, Javascript, HTML/CSS, and responsive web design to build cool full-stack websites. I craft high-performing, beautiful websites that are conversion-focused, brand-accurate, & people-friendly. I mostly love crafting beautiful, modern and ux friendly frontend ui. However Backend is more beautiful when we know how everything is working.</p>
            </div>
        </>
    );
};

export default About;